module.exports = __webpack_public_path__ + "img/excel.49762ab5.svg";